import React, { useContext } from "react";
import { Route, Navigate } from "react-router-dom";
import Home from "../layouts/home/index";
import { PayLoadCtx, RoleCtx } from "../lib/context";

const PaymentRoute = ({ children }) => {
    const { payload } = useContext(PayLoadCtx);
    const { role } = useContext(RoleCtx);
    return payload && role === "C" ? <Home role="Clinic">{children}</Home> : <Navigate to="/" />;
};

export default PaymentRoute;
